import React from 'react';

/**
 * Professional Tab Navigation Stepper
 * Clean, minimal design matching ASTUDIO aesthetic
 */
const TabNavigation = ({ currentTab, onTabChange, cvUploaded, disabled }) => {
  const tabs = [
    {
      id: 1,
      label: 'Upload CV',
      icon: (
        <svg className="tab-icon" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="12" y1="18" x2="12" y2="12"/>
          <line x1="9" y1="15" x2="15" y2="15"/>
        </svg>
      ),
      disabled: false,
      completed: currentTab > 1
    },
    {
      id: 2,
      label: 'Complete Profile',
      icon: (
        <svg className="tab-icon" viewBox="0 0 24 24">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      disabled: !cvUploaded,
      completed: currentTab > 2
    },
    {
      id: 3,
      label: 'Continue on Whatsapp',
      icon: (
        <svg className="tab-icon" viewBox="0 0 24 24" fill="none">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" strokeWidth="0"/>
          <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c1.746.943 3.71 1.44 5.709 1.44h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.479-8.413zm-8.475 18.299c-1.776 0-3.517-.477-5.029-1.379l-.361-.214-3.741.98.998-3.648-.235-.374c-.99-1.574-1.512-3.393-1.512-5.26.004-5.45 4.437-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898 1.867 1.867 2.893 4.35 2.89 6.988-.003 5.45-4.437 9.893-9.886 9.893z" strokeWidth="0"/>
        </svg>
      ),
      disabled: currentTab !== 3,
      completed: false
    }
  ];

  const handleTabClick = (tab) => {
    if (!tab.disabled && tab.id !== currentTab && !disabled) {
      onTabChange(tab.id);
    }
  };

  return (
    <div className={`tab-navigation ${disabled ? 'disabled' : ''}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab-button ${currentTab === tab.id ? 'active' : ''} ${tab.completed ? 'completed' : ''}`}
          onClick={() => handleTabClick(tab)}
          disabled={(tab.disabled && currentTab !== tab.id) || disabled}
        >
          <div className="tab-icon-wrapper">
            {tab.icon}
          </div>
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
